// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-select {
  font-family: "Proxima Nova", sans-serif;
  position: relative;
}
.custom-select .input-wrapper {
  display: flex;
  align-items: center;
  align-content: center;
  padding: 8px;
  border-radius: 8px;
  background-color: #F9F9F9;
  border: 1px solid #F9F9F9;
  transition: 0.2s all ease-in-out;
  cursor: pointer;
  white-space: nowrap;
}
.custom-select .input-wrapper.secondary {
  background-color: #ffffff;
  border-color: #C9C9C9;
}
.custom-select .input-wrapper.secondary input, .custom-select .input-wrapper.secondary .input-text {
  color: #5F5F5F;
}
.custom-select .input-wrapper.secondary input::placeholder, .custom-select .input-wrapper.secondary .input-text::placeholder {
  color: #5F5F5F;
}
.custom-select .input-wrapper.show .right-slot svg {
  transform: rotate(0deg) !important;
}
.custom-select .input-wrapper.large {
  padding: 14px;
}
.custom-select .input-wrapper.large input, .custom-select .input-wrapper.large .input-text {
  font-size: 14px;
}
.custom-select .input-wrapper.small {
  padding: 4px 10px 4px 14px;
}
.custom-select .input-wrapper.small input, .custom-select .input-wrapper.small .input-text {
  font-size: 10px;
}
.custom-select .input-wrapper input, .custom-select .input-wrapper .input-text {
  border: none;
  background-color: inherit;
  color: #949494;
  font-weight: 500;
  font-size: 12px;
  width: 100%;
  cursor: pointer;
  caret-color: transparent;
}
.custom-select .input-wrapper input::placeholder, .custom-select .input-wrapper .input-text::placeholder {
  color: #949494;
}
.custom-select .input-wrapper input:focus, .custom-select .input-wrapper .input-text:focus {
  outline: none;
}
.custom-select .input-wrapper .right-slot svg {
  transition: 0.2s ease-in-out;
  transform: rotate(180deg);
}
.custom-select .select-menu {
  position: absolute;
  margin-top: 10px;
  background-color: white;
  padding: 20px 14px;
  width: 100%;
  box-shadow: 0px 5px 20px 0px #EBEBEB;
  z-index: 5;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  opacity: 0;
  visibility: hidden;
  max-height: 300px;
  overflow: auto;
}
.custom-select .select-menu.remove {
  opacity: 0;
  visibility: hidden;
  animation: slideup 0.3s;
  transition: all 0.3s ease-in-out 0s;
}
.custom-select .select-menu.show {
  animation: slidedown 0.3s;
  animation-timing-function: ease-in-out;
  visibility: visible;
  opacity: 1;
}
.custom-select .select-menu > li {
  font-weight: 500;
  line-height: 20px;
  font-size: 12px;
  cursor: pointer;
  color: #5F5F5F;
}
.custom-select .select-menu > li:hover {
  color: #2a2a2a;
}
.custom-select .select-menu > li.selected {
  color: var(--primary-color-1);
}
@keyframes slideup {
  from {
    margin-top: 10px;
    opacity: 1;
  }
  to {
    margin-top: 0px;
    opacity: 0;
  }
}
@keyframes slidedown {
  from {
    margin-top: 0px;
    opacity: 0;
  }
  to {
    margin-top: 10px;
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CustomSelect/customSelect.scss"],"names":[],"mappings":"AAWA;EACI,uCAAA;EACA,kBAAA;AAVJ;AAYI;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBArBG;EAsBH,yBAAA;EACA,gCAAA;EACA,eAAA;EACA,mBAAA;AAVR;AAWQ;EACI,yBAxBS;EAyBT,qBAxBa;AAezB;AAUY;EACI,cAzBO;AAiBvB;AASgB;EACI,cA3BG;AAoBvB;AAagB;EACI,kCAAA;AAXpB;AAgBQ;EACI,aAAA;AAdZ;AAgBY;EACI,eAAA;AAdhB;AAkBQ;EACI,0BAAA;AAhBZ;AAkBY;EACI,eAAA;AAhBhB;AAoBQ;EACI,YAAA;EACA,yBAAA;EACA,cA9DC;EA+DD,gBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,wBAAA;AAlBZ;AAmBY;EACI,cArEH;AAoDb;AAoBY;EACI,aAAA;AAlBhB;AAsBY;EACI,4BAAA;EACA,yBAAA;AApBhB;AAwBI;EACI,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,oCAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AAtBR;AAuBQ;EACI,UAAA;EACA,kBAAA;EACA,uBAAA;EACA,mCAAA;AArBZ;AAuBQ;EACI,yBAAA;EACA,sCAAA;EACA,mBAAA;EACA,UAAA;AArBZ;AAuBQ;EACI,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,cA7GO;AAwFnB;AAsBY;EACI,cAAA;AApBhB;AAsBY;EACI,6BAAA;AApBhB;AAwBI;EACI;IAAS,gBAAA;IAAkB,UAAA;EApBjC;EAqBM;IAAK,eAAA;IAAiB,UAAA;EAjB5B;AACF;AAkBI;EACI;IAAO,eAAA;IAAiB,UAAA;EAd9B;EAeM;IAAO,gBAAA;IAAkB,UAAA;EAX/B;AACF","sourcesContent":["$input-bg: #F9F9F9;\n$input-text: #949494;\n\n$input-secondary-bg: #ffffff;\n$input-secondary-border: #C9C9C9;\n$input-secondary-text: #5F5F5F;\n\n$input-focus-border: #949494;\n$input-focus-text: #5F5F5F;\n\n\n.custom-select {\n    font-family: 'Proxima Nova', sans-serif;\n    position: relative;\n\n    .input-wrapper {\n        display: flex;\n        align-items: center;\n        align-content: center;\n        padding: 8px;\n        border-radius: 8px;\n        background-color: $input-bg;\n        border: 1px solid $input-bg;\n        transition: .2s all ease-in-out;\n        cursor: pointer;\n        white-space: nowrap;\n        &.secondary {\n            background-color: $input-secondary-bg;\n            border-color: $input-secondary-border;\n            input, .input-text {\n                color: $input-secondary-text;\n                &::placeholder {\n                    color: $input-secondary-text;\n                }\n            }\n        } \n        &.show {\n            .right-slot {\n                svg {\n                    transform: rotate(0deg) !important;\n                }\n            }\n        }\n\n        &.large {\n            padding: 14px;\n\n            input, .input-text {\n                font-size: 14px;\n            }\n        }\n\n        &.small {\n            padding: 4px 10px 4px 14px;\n\n            input, .input-text {\n                font-size: 10px;\n            }\n        }\n\n        input, .input-text {\n            border: none;\n            background-color: inherit;\n            color: $input-text;\n            font-weight: 500;\n            font-size: 12px;\n            width: 100%;\n            cursor: pointer;\n            caret-color: transparent; \n            &::placeholder {\n                color: $input-text;\n            }\n\n            &:focus {\n                outline: none;\n            }\n        }\n        .right-slot {\n            svg {\n                transition: .2s ease-in-out;\n                transform: rotate(180deg);\n            }\n        }\n    }\n    .select-menu {\n        position: absolute;\n        margin-top: 10px;\n        background-color: white;\n        padding: 20px 14px;\n        width: 100%;\n        box-shadow: 0px 5px 20px 0px #EBEBEB;\n        z-index: 5;\n        border-radius: 8px;\n        display: flex;\n        flex-direction: column;\n        row-gap: 10px;\n        opacity: 0;\n        visibility: hidden;\n        max-height: 300px;\n        overflow: auto;\n        &.remove {\n            opacity: 0;\n            visibility: hidden;\n            animation: slideup .3s;\n            transition: all 0.3s ease-in-out 0s;\n        }\n        &.show {\n            animation: slidedown .3s;\n            animation-timing-function: ease-in-out;\n            visibility: visible;\n            opacity: 1;\n        }\n        > li {\n            font-weight: 500;\n            line-height: 20px;\n            font-size: 12px;\n            cursor: pointer;\n            color: $input-focus-text;\n            &:hover {\n                color: #2a2a2a;\n            }\n            &.selected {\n                color: var(--primary-color-1);\n            }\n        }\n    }\n    @keyframes slideup {\n        from   { margin-top: 10px; opacity: 1;}\n        to { margin-top: 0px; opacity: 0;}\n    }\n    @keyframes slidedown {\n        from { margin-top: 0px; opacity: 0;}\n        to   { margin-top: 10px; opacity: 1;}\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
